var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.certifications)?_c('div',[_c('ce-certification-filter',{attrs:{"certifications":_vm.certifications,"region":"overall"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }